import i18n from "../../i18n";
import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowRight, Bell, AlertTriangle } from "lucide-react";

const sevClass = {
    high: "border-rose-500/30 bg-rose-500/5 text-rose-700",
    medium: "border-amber-500/30 bg-amber-500/5 text-amber-700",
    low: "border-blue-500/30 bg-blue-500/5 text-blue-700",
};

export default function EmployeeAlertsPage() {
    const [data, setData] = useState(null);

    useEffect(() => {
        api.get("/alerts-unified").then((r) => setData(r.data)).catch(() => setData({ alerts: [], total: 0, by_severity: {} }));
    }, []);

    if (!data) {
        return <div className="py-8 text-sm text-muted-foreground">{i18n.t("batch4.632383067662")}</div>;
    }

    return (
        <div className="space-y-4" data-testid="employee-alerts-page">
            <div>
                <div className="text-[11px] uppercase tracking-[0.25em] text-muted-foreground flex items-center gap-2">
                    <Bell className="w-4 h-4" />{i18n.t("batch4.d0efe0b2c75c")}
                </div>
                <h2 className="text-2xl font-bold mt-1">{i18n.t("batch4.113f5ddb1051")}</h2>
                <p className="text-sm text-muted-foreground">{i18n.t("batch4.f549dc5349fc")}</p>
            </div>

            <Card className="p-4">
                <div className="grid grid-cols-3 gap-3 text-center">
                    <Stat label={i18n.t("batch4.b1a5954a483f")} value={data.by_severity?.high ?? 0} />
                    <Stat label={i18n.t("batch4.d404968ea90b")} value={data.by_severity?.medium ?? 0} />
                    <Stat label={i18n.t("batch4.b25928c69902")} value={data.total ?? 0} />
                </div>
            </Card>

            <div className="space-y-3">
                {(data.alerts || []).length === 0 ? (
                    <Card className="p-6 text-sm text-muted-foreground text-center">{i18n.t("batch4.b9d5d070e883")}</Card>
                ) : (
                    (data.alerts || []).map((alert) => (
                        <Card key={alert.id} className={`p-4 border ${sevClass[alert.severity] || sevClass.low}`}>
                            <div className="flex items-start gap-3">
                                <div className="w-10 h-10 rounded-xl bg-background/80 grid place-items-center shrink-0">
                                    <AlertTriangle className="w-4 h-4" />
                                </div>
                                <div className="flex-1 min-w-0">
                                    <div className="flex items-center gap-2 flex-wrap">
                                        <Badge variant="outline" className="text-[10px] uppercase tracking-wider">{alert.module}</Badge>
                                        <Badge variant="outline" className="text-[10px] uppercase tracking-wider">{alert.severity}</Badge>
                                    </div>
                                    <div className="font-semibold mt-1">{alert.title}</div>
                                    <div className="text-sm text-muted-foreground">{alert.description || "No data"}</div>
                                </div>
                                <ArrowRight className="w-4 h-4 text-muted-foreground shrink-0 mt-1" />
                            </div>
                        </Card>
                    ))
                )}
            </div>
        </div>
    );
}

function Stat({ label, value }) {
    return (
        <div className="rounded-2xl border border-border bg-secondary/40 p-3">
            <div className="text-[11px] uppercase tracking-[0.2em] text-muted-foreground">{label}</div>
            <div className="mt-1 text-2xl font-bold">{value}</div>
        </div>
    );
}
